const $backToTop = document.getElementById('back_to_top');
let visibleTreshold = 200;

$backToTop.addEventListener('click', () => document.documentElement.scrollTop = 0);

window.onscroll = function () {
  if (document.body.scrollTop > visibleTreshold || document.documentElement.scrollTop > visibleTreshold) {
    $backToTop.classList.remove("is--hidden");
  } else {
    $backToTop.classList.add("is--hidden");
  }
};